module.exports = __webpack_public_path__ + "static/media/transaction-history.75baee0b.svg";